import { useState } from 'react'
import { pairWithCode } from '@/lib/api-client'

interface PairingState {
  loading: boolean
  error: string | null
  success: boolean
  orgName: string | null
  userName: string | null
}

interface UsePairingResult extends PairingState {
  pair: (code: string) => Promise<void>
  reset: () => void
}

export function usePairing(onSuccess?: () => void): UsePairingResult {
  const [state, setState] = useState<PairingState>({
    loading: false,
    error: null,
    success: false,
    orgName: null,
    userName: null,
  })

  async function pair(code: string) {
    if (state.loading || state.success) return
    setState((s) => ({ ...s, loading: true, error: null }))

    const result = await pairWithCode(code, 'Athenty Outlook Add-in')

    if (result.success) {
      setState({
        loading: false,
        error: null,
        success: true,
        orgName: result.orgName,
        userName: result.userName,
      })
      setTimeout(() => onSuccess?.(), 1200)
    } else {
      setState((s) => ({ ...s, loading: false, error: result.error ?? 'Invalid or expired code.' }))
    }
  }

  function reset() {
    setState({ loading: false, error: null, success: false, orgName: null, userName: null })
  }

  return { ...state, pair, reset }
}
